import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { includes, isEmpty, map, toNumber } from 'lodash';
import { Form, Col } from 'react-bootstrap';

import handleErrorInClient from '../../../modules/handle-error-in-client';
import methodPromise from '../../../modules/method-promise-wrapper';

import { LAYER_SUBTYPES, LAYER_TYPES } from '../../../api/Layers/Layers';
import * as layerOps from '../../../api/Layers/layer-operations';

import LoadButton from '../LoadButton';

// eslint-disable-next-line consistent-return
const loadPostgreSQLAttributes = async (event, layerType) => {
  try {
    const loadParameters = {
      database: event.target.form.database.value.trim(),
      host: event.target.form.ipaddress.value.trim(),
      password: event.target.form.password.value.trim(),
      port: toNumber(event.target.form.port.value),
      schema: event.target.form.schema.value.trim(),
      table: event.target.form.table.value.trim(),
      user: event.target.form.user.value.trim()
    };
    const attributes = await methodPromise('layers.loadPostgreSQLAttributes', {
      loadParameters,
      isThematic: layerType === LAYER_TYPES.THEMATIC
    });
    if (isEmpty(attributes)) throw new Error('No attributes found');
    return attributes;
  } catch (error) {
    handleErrorInClient(error);
  }
};

const LayerPostgreSQLFields = ({
  geojsonLoading,
  layer,
  layerSubType,
  layerType,
  loadPostgreSQL
}) => {
  if (includes([LAYER_SUBTYPES.POSTGRESQL, LAYER_SUBTYPES.WMS], layerSubType)) {
    const defaultAttributes = layerOps.isSpatial(layer)
      ? map(layerOps.getGeoJSONProps(layer), 'name')
      : layerOps.getThematicKeyList(layer);
    const [postgreSQLAttributes, handlePostgreSQLAttributes] = useState(defaultAttributes);
    const handleAttributesState = async event => {
      const attributes = await loadPostgreSQLAttributes(event, layerType);
      handlePostgreSQLAttributes(attributes);
    };
    return (
      <>
        <Form.Row>
          {layerSubType !== LAYER_SUBTYPES.WMS && (
            <>
              <Form.Group as={Col} xs={6}>
                <Form.Label>IP Address</Form.Label>
                <Form.Control type="text" name="ipaddress" defaultValue={layerOps.getHost(layer)} />
              </Form.Group>
              <Form.Group as={Col} xs={6}>
                <Form.Label>Port</Form.Label>
                <Form.Control type="number" name="port" defaultValue={layerOps.getPort(layer)} />
              </Form.Group>
            </>
          )}
          <Form.Group as={Col} xs={6}>
            <Form.Label>User</Form.Label>
            <Form.Control
              type="text"
              name="user"
              autoComplete="new-password"
              defaultValue={layerOps.getUser(layer)}
            />
          </Form.Group>
          <Form.Group as={Col} xs={6}>
            <Form.Label>Password</Form.Label>
            <Form.Control
              type="password"
              name="password"
              autoComplete="new-password"
              defaultValue={layerOps.getPassword(layer)}
            />
          </Form.Group>
          {layerSubType !== LAYER_SUBTYPES.WMS && (
            <>
              <Form.Group as={Col} xs={6}>
                <Form.Label>Database</Form.Label>
                <Form.Control
                  type="text"
                  name="database"
                  defaultValue={layerOps.getDatabase(layer)}
                />
              </Form.Group>
              <Form.Group as={Col} xs={6}>
                <Form.Label>Schema</Form.Label>
                <Form.Control type="text" name="schema" defaultValue={layerOps.getSchema(layer)} />
              </Form.Group>
              <Form.Group as={Col} xs={6}>
                <Form.Label>Table</Form.Label>
                <Form.Control type="text" name="table" defaultValue={layerOps.getTable(layer)} />
              </Form.Group>
              <Form.Group as={Col} xs={6} className="pt-4">
                <LoadButton isLoading={geojsonLoading} clickAction={handleAttributesState} />
              </Form.Group>
            </>
          )}
        </Form.Row>
        {!isEmpty(postgreSQLAttributes) && layerSubType !== LAYER_SUBTYPES.WMS && (
          <Form.Row>
            <Col xs={12}>
              <Form.Label>Attributes</Form.Label>
            </Col>
            <Form.Group as={Col} xs={8}>
              <Form.Control as="select" multiple name="postgreSQLAttributes">
                {map(postgreSQLAttributes, attribute => {
                  return (
                    <option value={attribute} key={attribute}>
                      {attribute}
                    </option>
                  );
                })}
              </Form.Control>
            </Form.Group>
            <Col xs={4}>
              <LoadButton isLoading={geojsonLoading} clickAction={loadPostgreSQL} />
            </Col>
          </Form.Row>
        )}
      </>
    );
  }
  return '';
};
LayerPostgreSQLFields.propTypes = {
  layer: PropTypes.object.isRequired,
  layerSubType: PropTypes.string.isRequired,
  layerType: PropTypes.string.isRequired,
  geojsonLoading: PropTypes.bool.isRequired,
  loadPostgreSQL: PropTypes.func.isRequired
};

export default LayerPostgreSQLFields;
